import { useEffect } from 'react';
import SelectField from 'components/forms/selectField/SelectField';
import { useTranslation } from 'react-i18next';
import { useFormContext, useWatch } from 'react-hook-form';
import useImportBookingDotComPropertiesModalInit from '../../useImportBookingDotComPropertiesModalInit';

const LegalEntityIDInput = () => {
  const { t } = useTranslation();
  const { legalEntityId } = useWatch();
  const { contracts } = useImportBookingDotComPropertiesModalInit();
  const { setValue } = useFormContext();

  // @ts-expect-error TS18048 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
  const contractsOptions = contracts.map(
    ({ legalEntityId: le, legalContactEmail }) => ({
      label: `${le} - ${legalContactEmail}`,
      value: le,
    }),
  );

  useEffect(() => {
    // @ts-expect-error TS18048 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
    if (!legalEntityId && contracts?.length > 0) {
      setValue('legalEntityId', contracts?.[0]?.legalEntityId);
    }
  }, [contracts, legalEntityId]);

  return (
    <SelectField
      label={t(
        'pageProperties.importBookingDotComPropertiesModal.legalEntityID',
      )}
      name="legalEntityId"
      options={contractsOptions}
      colSmInput={9}
      colSmLabel={3}
      required
    />
  );
};

export default LegalEntityIDInput;
